import { mapGetters } from "vuex";

export default {
    data() {
        return {
            uploadProgress: 0,
            isUploading: false,
            // chunkSize: 1024 * 1024 * 1, // 1 MB
            retryCount: 1,
            retryDelay: 500,
        };
    },
    computed: {
        ...mapGetters({
            tenantSettingConfig: "tenant/tenantSettingConfig",
        }),
        chunkSize() {
            const chunkSetting = this.tenantSettingConfig("chunkSetting");
            const defaultChunkSize = 1024 * 1024;

            return chunkSetting ? defaultChunkSize * Number(chunkSetting.chunkSetting) : defaultChunkSize * 10;
        }
    },
    methods: {
        async uploadFileInChunks(file, formData) {
            const totalChunks = Math.ceil(file.size / this.chunkSize);
            this.isUploading = true;
            this.uploadProgress = 0;
            let response;
            for (let chunkIndex = 0; chunkIndex < totalChunks; chunkIndex++) {
                const start = chunkIndex * this.chunkSize;
                const end = Math.min(start + this.chunkSize, file.size);
                const chunk = file.slice(start, end);
                const checksum = await this.computeChecksum(chunk);

                let attempts = 0;
                let success = false;

                while (attempts < this.retryCount && !success) {
                    try {
                        response = await this.uploadChunk(chunk, chunkIndex, totalChunks, checksum, formData);
                        success = true;
                    } catch (error) {
                        attempts++;
                        if (attempts < this.retryCount) {
                            await this.delay(this.retryDelay);
                        }
                        else {
                            throw error;
                        }
                    }
                }

                if (!success) {
                    this.isUploading = false;
                    return response;
                }

                this.uploadProgress = ((chunkIndex + 1) / totalChunks) * 100;
            }

            this.isUploading = false;
            return response
        },
        async uploadChunk(chunk, chunkIndex, totalChunks, checksum, formData) {
            return new Promise(async (resolve, reject) => {
                formData.set("file", chunk);
                this.setFormDataField(formData, "chunkIndex", chunkIndex);
                this.setFormDataField(formData, "totalChunks", totalChunks);
                this.setFormDataField(formData, "checksum", checksum);

                try {
                    const result = await this.createDocuments(formData);
                    resolve(result);
                } catch (error) {
                    reject(error);
                }
            });
        },
        setFormDataField(formData, key, value) {
            if (formData.has(key)) {
                formData.set(key, value);
            } else {
                formData.append(key, value);
            }
        },
        async computeChecksum(chunk) {
            const arrayBuffer = await chunk.arrayBuffer();
            const hashBuffer = await window.crypto.subtle.digest("SHA-256", arrayBuffer); // hash the message
            const hashArray = Array.from(new Uint8Array(hashBuffer)); // convert buffer to byte array
            const hashHex = hashArray
                .map((b) => b.toString(16).padStart(2, "0"))
                .join(""); // convert bytes to hex string
            return hashHex;
        },
        delay(ms) {
            return new Promise((resolve) => setTimeout(resolve, ms));
        },
    }
}

